import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Location } from '@angular/common';
import * as XLSX from "xlsx";
import Swal from 'sweetalert2';
import { IService, Service } from '../../../../../../models/service.model';
import { ProductService } from '../../../../../../services/product.service';
import { EncryptionService } from '../../../../../../services/EncryptionService';
import { ServiceService } from '../../../../../../services/service.service';
import { SharedFonctionsService } from '../../../../../../services/shared-fonctions.service';
import { environment } from '../../../../../../environments/environment';
import { FormBuilder, FormControl } from '@angular/forms';
@Component({
  selector: 'app-list-service',
  templateUrl: './list-service.component.html',
  styleUrls: ['./list-service.component.scss']
})
export class ListServiceComponent implements OnInit {

  url_photo:any;
  filter = false;
  pageNumber: number = 1;
  pageSize: number = 10;
  totalItems :any;
  services: IService[] =[];
  service: IService;
  servicesTmp:IService[]=[];
  p = 1;
  search: any;

  // @ts-ignore
  public modalRef: BsModalRef;

  sharedIdShop : any;
  sharedINameShop : String;
  constructor(private router:Router,private productService: ProductService,private location: Location,
              private encryptionService: EncryptionService,private fb: FormBuilder,
              private sharedSevice: SharedFonctionsService,private servService:ServiceService) { }

  ngOnInit(): void {
    this.url_photo=environment.url_photo;
    this.sharedIdShop = this.sharedSevice.shopIdPartagee;
    this.sharedINameShop = this.sharedSevice.shopNamePartagee;
    if(this.sharedIdShop == undefined || this.sharedIdShop == null) {
      let shopid = window.localStorage.getItem("khshshopid!#");
      let shopname = window.localStorage.getItem("khshshopname!#");
      if(shopid != null && shopid != undefined){
        let decr = this.encryptionService.decryptionAES(shopid);
        let decr1 = this.encryptionService.decryptionAES(shopname);
        this.sharedIdShop = decr;
        this.sharedINameShop = decr1;
      }
    }
    this.loadService();
  }


  loadService = () => {
    // console.log("Boutique.....")
    // console.log(this.sharedIdShop)
    if(this.sharedIdShop){
      this.servService.getServiceByShopPaged(this.sharedIdShop, this.pageNumber-1, this.pageSize).subscribe((data :any)=>{
        this.services = data.content;
        this.servicesTmp = data.content;
        this.totalItems = data.totalElements;
        // console.log('👉️👉️👉️👉️ LISTE DES SERVICES')
        // console.log(this.services)
      })
    }
  };

  searchFilter($event: KeyboardEvent) {
    this.search = this.search.toString().toLowerCase();

    this.servicesTmp.filter(
      value => value.titre?.toLowerCase().includes(this.search) || value.category?.name?.toLowerCase().includes(this.search) || value.shop?.name?.toLowerCase().includes(this.search)
      || value.titre?.includes(this.search) || value.category?.name?.includes(this.search) || value.shop?.name?.includes(this.search)
      || value.titre?.toLowerCase().includes(this.search) || value.category?.name?.toLowerCase().includes(this.search) || value.shop?.name?.toLowerCase().includes(this.search)
    )

  }

  deleteService(serv:IService){
    Swal.fire({
      title: 'Voulez-vous vraiment supprimer ce service ?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonText: 'Non',
      confirmButtonText: 'Oui'
    }).then((result) => {
      if (result.isConfirmed) {
        this.servService.deleteService(serv).subscribe(
          rs=> {

            // console.log(rs)
            Swal.fire({
              position: 'top-end',
              icon: 'success',
              title: 'Votre service est supprimé avec succès.',
              showConfirmButton: false,
              timer: 1500
            });
            this.services = [...this.services];
            this.loadService();
            this.reloadComponent();
          }, error => {
            // console.log(error);
            Swal.fire({
              position: 'top-end',
              icon: 'error',
              title: 'Erreur de suppression <br>'+error.error.errorMessage,
              showConfirmButton: false,
              timer: 1500
            })
          }
        )
      }
    })

  }

  detailsService(serv:IService){
    this.service = serv;
    // console.log("Service sélectionnée...");
    // console.log(this.service)
  }

  selected: boolean = false;
  imageName: string | undefined = '';
  getUrlPhoto() {
    this.imageName = this.service?.photo;
    if(this.imageName != null || this.imageName != undefined){
      this.selected = true;
    }else {
      this.selected = false;
    }
  }

  reloadComponent() {
    let currentUrl = this.router.url;
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate([currentUrl]);
  }

  dateForm = this.fb.group({
    beginDate: new FormControl(''),
    endDate: new FormControl('')
  })

  goBack(): void {
    this.location.back();
  }

  beginDateVal: any = null;
  displayErrorMessage: boolean = false;
  getBeginDate(event: any) {
    this.beginDateVal = event.target.value;
    if(this.beginDateVal != null){
      this.disableEndDate = false;
      if(this.beginDateVal > this.endDateVal){
        this.displayErrorMessage = true;
      }else {
        this.displayErrorMessage = false;
      }
    }
  }

  endDateVal: any = null;
  disableEndDate: boolean = true;
  getEndDate(event: any) {
    this.endDateVal = event.target.value;
    //console.log(this.endDateVal);
    if(this.beginDateVal > this.endDateVal){
      this.displayErrorMessage = true;
    }else{
      this.displayErrorMessage = false;
    }
  }

  refresh() {
    this.loadService();
    this.dateForm.patchValue({
      beginDate: '',
      endDate: ''
    })
  }

  filterByDate() {
    const beginDate = new Date(this.dateForm.get('beginDate').value).toISOString();
    const endDate = new Date(this.dateForm.get('endDate').value).toISOString();
    // console.log("Date sélectionnée")
    // console.log('beginDate:', beginDate);
    // console.log('endDate:', endDate);
    if(!beginDate || !endDate) {
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Veuillez renseigner la date de début et la date de fin',
        showConfirmButton: false,
        timer: 3500
      });
      return;
    }else{
      this.servService.getKahpooShopsServiceByDate(this.sharedIdShop, beginDate, endDate,this.pageNumber - 1, this.pageSize).subscribe(data =>{
        this.services = data.content;
        this.servicesTmp = data.content;
        this.totalItems = data.totalElements;
      });
    }
  }

  searchServices($event: KeyboardEvent) {
    this.services = this.servicesTmp.filter(value =>
      value?.titre.toLowerCase().includes(this.search.toLowerCase().trim()) ||
      value?.serviceID.toLowerCase().includes(this.search.toLowerCase().trim()) ||
      value?.category?.name?.toLowerCase().includes(this.search.toLowerCase().trim()) ||
      value?.shop?.city?.name.toLowerCase().includes(this.search.toLowerCase().trim()) ||
      value?.shop?.city?.country?.iso.toLowerCase().includes(this.search.toLowerCase().trim()) ||
      value?.shop?.sellerId?.firstname.toLowerCase().includes(this.search.toLowerCase().trim()) ||
      value?.shop?.sellerId?.lastname.toLowerCase().includes(this.search.toLowerCase().trim()) ||
      value?.shop?.address.toLowerCase().includes(this.search.toLowerCase().trim()) ||
      (Number(this.search) === Number(value?.shop?.mobile))
    )
  }

  raiseTableSize(event: any) {
    this.pageSize = event.target.value;
    this.loadService();
  }

  exportPostToExelFile(filename: string) {
    const data = document.getElementById('tab-post');
    const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(data);

    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, filename);
  }

}
